module.exports = __webpack_public_path__ + "static/media/sprayers.8a44d391.jpg";